import React from "react";
import { useNavigate } from "react-router-dom";
import "./INIDEPRUEBA.css";
import fondo from "./ismaael.jpeg";
import sera from "./sera.png";
import { Link } from "react-router-dom";
import MenuPrincipal from "./MenuPrincipal";

export default function ComicVideoBase({
  titulo,
  portada,
  video = "",
  sugeridos = [],
  info = {},
}) {
  const navigate = useNavigate();

  const portadaFinal = portada || sera;

  const {
    grupo = "N/A",
    tipo = "Video",
    idioma = "Español",
    serie = "N/A",
    personajes = [],
    etiquetas = ["Video"],
    artistas = "Desconocido",
  } = info;

  // =====================================================
  // 🚀 IMPORTAR TODOS LOS COMICS
  // =====================================================
  const contextComics = require.context("./pages", true, /\.jsx$/);

  const todosLosComics = contextComics
    .keys()
    .map((key) => {
      try {
        const modulo = contextComics(key);
        const data = modulo.infoManga;

        return {
          titulo: data.titulo,
          portada: data.portada,
          enlace: data.enlace,
          info: data.info,
        };
      } catch (err) {
        console.error("Error cargando", key, err);
        return null;
      }
    })
    .filter(Boolean);

  // =====================================================
  // 🚀 NORMALIZAR
  // =====================================================
  const normalizar = (texto) =>
    texto
      ?.toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  // =====================================================
  // 🚀 SUGERIDOS
  // =====================================================
  const sugeridosFinales =
    sugeridos.length > 0
      ? sugeridos
      : todosLosComics
          .filter((comic) => comic.titulo !== titulo)
          .map((comic) => {
            let coincidencias = 0;

            const artistaA = normalizar(artistas);
            const artistaB = normalizar(comic.info?.artistas);

            const serieA = normalizar(serie);
            const serieB = normalizar(comic.info?.serie);

            const etiquetasA = (etiquetas || []).map(normalizar);
            const etiquetasB = (comic.info?.etiquetas || []).map(normalizar);

            const personajesA = (personajes || []).map(normalizar);
            const personajesB = (comic.info?.personajes || []).map(normalizar);

            if (artistaA && artistaA === artistaB) coincidencias += 2;
            if (serieA && serieA === serieB) coincidencias += 2;

            if (personajesB.some((p) => personajesA.includes(p)))
              coincidencias += 1;

            if (etiquetasB.some((et) => etiquetasA.includes(et)))
              coincidencias += 1;

            return { ...comic, coincidencias };
          })
          .filter((c) => c.coincidencias > 0)
          .sort((a, b) => b.coincidencias - a.coincidencias)
          .slice(0, 5);

  // =====================================================
  // 🚀 CONTINUACIONES
  // =====================================================
  const limpiarTituloBase = (txt) =>
    normalizar(
      txt
        .replace(/capitulo[\s_-]*\d+/gi, "")
        .replace(/chapter[\s_-]*\d+/gi, "")
        .replace(/parte[\s_-]*\d+/gi, "")
        .replace(/part[\s_-]*\d+/gi, "")
        .replace(/\d+/g, "")
        .replace(/\b3d\b/gi, "")
        .replace(/rose\s*blue/gi, "")
        .replace(/roseblue/gi, "")
        .replace(/[^\w\s]/g, "")
        .replace(/\s+/g, " ")
        .trim()
    );

  const tituloBaseActual = limpiarTituloBase(titulo);

  const continuaciones = todosLosComics
    .filter((comic) => {
      const baseComic = limpiarTituloBase(comic.titulo);

      return (
        baseComic === tituloBaseActual &&
        normalizar(comic.titulo) !== normalizar(titulo)
      );
    })
    .sort((a, b) => {
      const numA = parseInt(a.titulo.match(/\d+/)?.[0] || 0);
      const numB = parseInt(b.titulo.match(/\d+/)?.[0] || 0);

      return numA - numB;
    });

  // =====================================================
  // 🚀 RENDER
  // =====================================================
  return (
    <div className="comic-base">

      {/* HEADER */}
      <header
        className="header-futurista"
        style={{ backgroundImage: `url(${fondo})` }}
      >
        <div className="overlay-header"></div>

        <h1 className="titulo-fx">
          {titulo || "TMOXNight"}
        </h1>

        <MenuPrincipal />
      </header>

      {/* MAIN */}
      <main className="detalle-fx">

        {/* IZQUIERDA */}
        <aside className="meta-fx">

          <h2>🎬 Video</h2>

          <div className="cover-fx">
            <img src={portadaFinal} alt="Portada" decoding="async" fetchPriority="high" />
          </div>

          <table className="info-fx">
            <tbody>

              <tr>
                <td>Grupo</td>
                <td>{grupo}</td>
              </tr>

              <tr>
                <td>Tipo</td>
                <td>{tipo}</td>
              </tr>

              <tr>
                <td>Idioma</td>
                <td>{idioma}</td>
              </tr>

              <tr>
                <td>Serie</td>
                <td>{serie}</td>
              </tr>

              <tr>
                <td>Artistas</td>
                <td>{artistas}</td>
              </tr>

            </tbody>
          </table>
        </aside>

        {/* DERECHA */}
        <section className="content-fx">

          <h2>🎥 Reproductor</h2>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
<iframe
  src={video}
  title={titulo}
  frameBorder="0"
  width="100%"
  height="700"
  scrolling="no"
  allowFullScreen
  sandbox="allow-same-origin allow-scripts allow-presentation"
  referrerPolicy="no-referrer"
  style={{
    maxWidth: "1100px",
    borderRadius: "20px",
    boxShadow: "0 0 30px rgba(0,255,255,0.4)",
    pointerEvents: "auto",
  }}
></iframe>
          </div>

          {/* CONTINUACIONES */}
          {continuaciones.length > 0 && (
            <>
              <h2 style={{ marginTop: "50px" }}>
                📚 Continuación
              </h2>

              <div className="continuaciones-lista">

                {continuaciones.map((comic, i) => (
                  <Link
                    key={i}
                    to={
                      comic.enlace ||
                      `/comic/${comic.titulo
                        .toLowerCase()
                        .replace(/[\s-]+/g, "")
                        .replace(/[^a-z0-9]/g, "")}`
                    }
                    className="continuacion-item"
                  >
                    📖 {comic.titulo}
                  </Link>
                ))}

              </div>
            </>
          )}

          {/* SUGERIDOS */}
          <h2 style={{ marginTop: "50px" }}>
            ⚡ Cómics sugeridos
          </h2>

          <div className="sugeridos-fx">

            {sugeridosFinales.map((comic, i) => (
              <Link
                key={i}
                to={
                  comic.enlace ||
                  `/comic/${comic.titulo
                    .toLowerCase()
                    .replace(/[\s-]+/g, "")
                    .replace(/[^a-z0-9]/g, "")}`
                }
                className={`sugerido-fx sugerido-${i + 1}`}
                style={{ "--img": `url(${comic.portada})` }}
                data-text={comic.titulo || `Comic ${i + 1}`}
              />
            ))}

          </div>

        </section>
      </main>

      {/* FOOTER */}
      <footer className="footer-fx">
        <p>
          &copy; 2025 TMOXNight — Todos los derechos reservados.
        </p>
      </footer>

    </div>
  );
}